module.exports = "/_next/static/images/mining-864876229ee6c1f20f0dd5f0b3831d9c.png.webp";